export default {

    setUser(state, user) {
        localStorage.setItem('user', JSON.stringify(user));
        state.user = user;
    },

    clearUser(state) {
        localStorage.removeItem('user');
        state.user = null;
    }

}
